import { apiClient } from "./client";
import type { LoginPayload, MeResponse } from "./types";

export async function login(payload: LoginPayload): Promise<void> {
  // Бэкенд возвращает 200 OK при успехе. Поля ответа специально не используем —
  // дальше дёргаем /me/ для получения полного state, чтобы избежать рассинхрона.
  await apiClient.post("/api/auth/login/", payload);
}

export async function logout(): Promise<void> {
  await apiClient.post("/api/auth/logout/");
}

export async function fetchMe(): Promise<MeResponse> {
  const { data } = await apiClient.get<MeResponse>("/api/auth/me/");
  return data;
}
